import { DraftDto, useApi } from '../../shared/api';
import { useMutation } from 'react-query';

type ResetDraftPayload = {
  id: string;
};

type Props = {
  onSuccess?: (draft: DraftDto) => void;
};

export function useResetDraft(props: Props = {}) {
  const { onSuccess } = props;
  const api = useApi();

  const mutation = useMutation<DraftDto, unknown, ResetDraftPayload>(
    'api/draft/reset',
    async (payload) => {
      const res = await api.blog.resetDraft(payload.id);

      return res.data;
    },
    {
      onSuccess,
    },
  );

  return mutation;
}
